<template>
	<div class="page-container">
		<el-card>
			<el-row class="title-biaoti">接口解析</el-row>
			<el-row class="search">
				<el-select style="width: 160px" v-model="channel" placeholder="请选择渠道" clearable filterable>
					<el-option v-for="(item, itemIndex) in channelList" v-bind:key="itemIndex" :label="item.label"
						:value="item.value"></el-option>
				</el-select>
				<el-upload class="upload-demo" :limit="1" action="" :on-change="addExcel" ref="upload">
					<el-button type="primary">接口解析</el-button>
				</el-upload>
				<el-button type="warning" @click="refresh" :loading="loading1">配置刷新</el-button>
				<el-button type="danger" @click="delData" :loading="loading3">删除解析数据</el-button>
			</el-row>
		</el-card>

		<el-card>
			<el-row class="title-biaoti">im协议解析</el-row>
			<el-row class="search">
				<el-select style="width: 160px" v-model="IMChannel" placeholder="请选择渠道" clearable filterable>
					<el-option v-for="(item, itemIndex) in channelList" v-bind:key="itemIndex" :label="item.label"
						:value="item.value"></el-option>
				</el-select>
				<el-upload class="upload-demo-1" :limit="1" action="" :on-change="addIMExcel" ref="uploadIM">
					<el-button type="primary">IM解析</el-button>
				</el-upload>

				<el-button type="danger" @click="delIMData" :loading="IMDelLoading">删除IM解析数据</el-button>
			</el-row>
		</el-card>

		<el-card>
			<el-row class="title-biaoti">内部路由解析</el-row>
			<el-row class="search">
				<el-select style="width: 160px" v-model="channel1" clearable filterable placeholder="请选择渠道">
					<el-option v-for="(item, itemIndex) in channelList" v-bind:key="itemIndex" :label="item.label"
						:value="item.value"></el-option>
				</el-select>
				<el-button type="primary" @click="query" :loading="loading">查询</el-button>
				<el-button type="warning" @click="operate(4)">新增</el-button>
			</el-row>
			<el-row>
				<el-table :data="tableList" v-loading="loading" height="60vh">
					<el-table-column prop="channel" label="渠道">
					</el-table-column>
					<el-table-column prop="host" label="服务端host">
					</el-table-column>
					<el-table-column prop="pathPre" label="接口前缀">
					</el-table-column>
					<el-table-column prop="serverName" label="服务名">
					</el-table-column>
					<el-table-column label="是否有效">
						<template slot-scope="scope">
							{{ scope.row.valid == 1 ? '有效' : '' }}
							{{ scope.row.valid == 2 ? '无效' : '' }}
						</template>
					</el-table-column>
					<el-table-column prop="mtime" label="修改时间">
					</el-table-column>
					<el-table-column prop="ctime" label="创建时间">
					</el-table-column>
					<el-table-column prop="operator" label="操作者">
					</el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
							<el-button size="mini" type="primary" @click="operate(1, scope.row)">修改</el-button>
							<el-button size="mini" type="danger" @click="operate(2, scope.row.id)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-row>
		</el-card>
		<el-dialog :title="type == 1 ? '修改' : '新增'" :visible.sync="dialog" width="50%" :before-close="handleClose">
			<div class="item">
				<span>渠道：</span><el-select v-model="data.channel" placeholder="">
					<el-option v-for="(item, itemIndex) in channelList" v-bind:key="itemIndex" :label="item.label"
						:value="item.value"></el-option>
				</el-select>
			</div>

			<div class="item">
				<span>服务名：</span><el-input type="text" v-model="data.serverName"></el-input>
			</div>
			<div class="item">
				<span>接口前缀：</span><el-input type="text" v-model="data.pathPre"></el-input>
			</div>
			<div class="item">
				<span>服务端host：</span><el-input type="text" v-model="data.host"></el-input>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="operate(3)" type="primary">
					保 存
				</el-button>
				<el-button @click="handleClose">取 消</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
import { allChannelList } from '@/utils/normalApi.js'
import { downloadZip } from '@/utils/downloadFile.js'
export default {
	data() {
		return {
			channel: '',
			channel1: '',
			channelList: [],
			tableList: [],
			loading: false,
			loading1: false,
			loading2: false,
			loading3: false,
			IMChannel: '',
			IMLoading: false,
			IMDelLoading: false,
			data: {},
			dialog: false,
			type: 0,
		}
	},
	async created() {
		this.channelList = await allChannelList()
		this.query()
	},
	methods: {
		async addExcel(file) {
			if (this.loading2) return
			if (this.channel == null || this.channel == '')
				return this.$message('渠道号不能为空')

			this.loading2 = true
			const formdata = new FormData()
			formdata.append('file', file.raw)
			const { data: res } = await this.$axios({
				responseType: 'blob',
				method: 'post',
				url:
					this.$store.getters.path.gateway_parse +
					'?username=' +
					this.$store.getters.username +
					'&token=' +
					this.$store.getters.token +
					'&channel=' +
					this.channel,
				data: formdata,
			})
			this.loading2 = false
			this.$refs.upload.clearFiles()
			downloadZip(res, '接口解析返回')
		},

		async addIMExcel(file) {
			if (this.IMLoading) return
			if (this.IMChannel == null || this.IMChannel == '')
				return this.$message('渠道号不能为空')
			this.IMLoading = true
			const formdata = new FormData()
			formdata.append('file', file.raw)
			const { data: res } = await this.$axios({
				responseType: 'blob',
				method: 'post',
				url:
					this.$store.getters.path.im_parse +
					'?username=' +
					this.$store.getters.username +
					'&token=' +
					this.$store.getters.token +
					'&channel=' +
					this.IMChannel,
				data: formdata,
			})
			this.IMLoading = false
			this.$refs.uploadIM.clearFiles()
			downloadZip(res, 'IM接口解析返回')
		},

		delIMData() {
			if (this.IMDelLoading) return
			if (this.IMChannel == null || this.IMChannel == '')
				return this.$message('渠道号不能为空')
			this.$confirm(`确认删除${this.IMChannel}渠道的IM数据解析`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			}).then(async () => {
				this.IMDelLoading = true
				const { data: res } = await this.$axios.post(
					this.$store.getters.path.im_del +
					'?username=' +
					this.$store.getters.username +
					'&token=' +
					this.$store.getters.token,
					{ channel: this.IMChannel }
				)
				this.IMDelLoading = false
				if (res.code !== 0) return this.$message.error('删除失败')
				this.$message.success('删除成功')
				this.IMChannel = ''
			})
		},

		delData() {
			if (this.loading3) return
			if (this.channel == null || this.channel == '')
				return this.$message('渠道号不能为空')
			this.$confirm(`确认删除${this.channel}渠道的数据解析`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			}).then(async () => {
				this.loading3 = true
				const { data: res } = await this.$axios.post(
					this.$store.getters.path.gateway_clear_parse_data +
					'?username=' +
					this.$store.getters.username +
					'&token=' +
					this.$store.getters.token,
					{ channel: this.channel }
				)
				this.loading3 = false
				if (res.code !== 0) return this.$message.error('删除失败')
				this.$message.success('删除成功')
				this.channel = ''
			})
		},
		async query() {
			this.loading = true
			const { data: res } = await this.$axios.post(
				this.$store.getters.path.gateway_query +
				'?username=' +
				this.$store.getters.username +
				'&token=' +
				this.$store.getters.token,
				{
					username: this.$store.getters.username,
					token: this.$store.getters.token,
					channel: this.channel1,
				}
			)
			this.loading = false
			if (res.code != 0) return this.$message(res.msg)
			this.tableList = res.data.list
		},
		async operate(type, obj) {
			if (type == 1) {
				this.dialog = true
				this.type = type
				this.data = { ...obj }
			} else if (type == 2) {
				this.$confirm('确认删除', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}).then(async () => {
					const { data: res } = await this.$axios.post(
						this.$store.getters.path.gateway_del +
						'?username=' +
						this.$store.getters.username +
						'&token=' +
						this.$store.getters.token,
						{ id: obj }
					)
					if (res.code !== 0) return this.$message.error('删除失败')
					this.$message.success('删除成功')
					this.query()
				})
			} else if (type == 3) {
				let data = {}
				this.type == 1
					? (data.id = this.data.id)
					: (data.operate = this.$store.getters.username)
				const { data: res } = await this.$axios.post(
					this.$store.getters.path.gateway_edit +
					'?username=' +
					this.$store.getters.username +
					'&token=' +
					this.$store.getters.token,
					{
						data: {
							...data,
							serverName: this.data.serverName,
							pathPre: this.data.pathPre,
							channel: this.data.channel,
							host: this.data.host,
						},
					}
				)
				if (res.code != 0) return this.$message(res.msg)
				this.$message.success('操作成功')
				this.query()
				this.handleClose()
			} else if (type == 4) {
				this.dialog = true
				this.type = type
			}
		},
		async refresh() {
			if (this.channel == null || this.channel == '')
				return this.$message('渠道号不能为空')
			this.loading1 = true
			const { data: res } = await this.$axios.post(
				this.$store.getters.path.gateway_refresh_config +
				'?username=' +
				this.$store.getters.username +
				'&token=' +
				this.$store.getters.token,
				{
					channel: this.channel1,
				}
			)
			this.loading1 = false
			if (res.code != 0) return this.$message(res.msg)
			return this.$message.success('刷新成功')
		},
		handleClose() {
			this.data = {}
			this.dialog = false
			this.type = 0
		},
	},
}
</script>
<style lang='scss' scoped>
.search {
	display: flex;
	align-items: center;

	>* {
		margin: 0 4px;
	}
}

.el-card+.el-card {
	margin-top: 10px;
}
</style>